/* @ngInject */
const myAreaCreateForm = (
  toaster,
  $$area
) => {
  return {
    restrict: 'E',
    scope: {
      myArea: '=',
      enableTitle: '=?',
      enableBack: '=?',
    },

    template: require('./myAreaCreateForm.html'),

    /* @ngInject */
    controller: ($scope) => {
      $scope.saveArea = async (_area) => {
        try {
          const formattedArea = $$area.format.server(_area)
          const response = await $$area.request.save(formattedArea)
          toaster.message(response.message)
          $scope.reinit()
        } catch (error) {
          toaster.error(error)
        }
      }

      $scope.reinit = () => {
        $scope.myArea = {}
        $scope.form.$setPristine()
        $scope.form.$setUntouched()
      }
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myAreaCreateForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/area/directives/forms/myAreaCreateForm.js